function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 2.4c-.3-.2-.8-.2-1.1 0L4.3 5.8c-.2.1-.4.2-.6.2H2v2h1c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H2v2h16v-2h-1c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h1V6h-1.7c-.2 0-.4-.1-.6-.2l-5.1-3.4zM14 9c0-.6-.4-1-1-1h-1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V9zM8 8c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgBank;